import { render, staticRenderFns } from "./updateEmployeeProfile.vue?vue&type=template&id=3a5c8a4a&scoped=true"
import script from "./updateEmployeeProfile.vue?vue&type=script&lang=js"
export * from "./updateEmployeeProfile.vue?vue&type=script&lang=js"
import style0 from "./updateEmployeeProfile.vue?vue&type=style&index=0&id=3a5c8a4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5c8a4a",
  null
  
)

export default component.exports